import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { injectIntl } from 'react-intl';
import { catalogBibShape, childrenShape, paginationShape } from '@bibliocommons/bc-prop-types';
import Context from '@bibliocommons/context';

import Heading from 'app/components/shared/Heading';
import ProgressBar from 'app/components/shared/ProgressBar';
import BackToLink from 'app/components/shared/BackToLink';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import Pagination from 'app/components/shared/Pagination';
import './BibSubPage.scss';

const PAGE_SIZES = {
  default: 'col-lg-7',
  large: 'col-lg-12'
};

export class BibSubPage extends React.PureComponent {
  renderHeader() {
    const { headerLocKey, pagination, showHeaderCount, headerCount } = this.props;
    let headerContents = this.props.intl.formatMessage({ id: headerLocKey });
    if (showHeaderCount) {
      if (pagination?.get('count') > 0) {
        headerContents += ` (${pagination.get('count')})`;
      } else if (headerCount) {
        headerContents += ` (${headerCount})`;
      }
    }
    return (
      <Heading className="page-heading" size="large" tagName="h1" variant>
        {headerContents}
      </Heading>
    );
  }

  renderPagination() {
    const { pagination } = this.props;
    return pagination && pagination.get('count') > 0 && <Pagination pagination={pagination} />;
  }

  render() {
    const { catalogBib, children, size, sourceComponent } = this.props;
    const classNames = cn('cp-bib-sub-page', 'container', {
      'bib-sub-page--mobile-app': this.context.mobileApp
    });
    return (
      <div className={classNames}>
        <ProgressBar active={this.props.isFetching} />
        {!this.context.mobileApp && (
          <div className="back-to-link-container">
            <BackToLink href={`/v2/record/${catalogBib.get('metadataId')}`} pageId="item_details" />
          </div>
        )}
        <div className="row">
          <div className={PAGE_SIZES[size]}>
            {this.renderHeader()}
            {catalogBib && (
              <BibBriefContainer
                metadataId={catalogBib.get('metadataId')}
                showAdditionalInfo={false}
                sourceComponent={sourceComponent}
                showTitleAsLink
                showJacketAsLink
              />
            )}
            {children}
            {this.renderPagination()}
          </div>
        </div>
      </div>
    );
  }
}

BibSubPage.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  headerLocKey: PropTypes.string.isRequired,
  showHeaderCount: PropTypes.bool,
  headerCount: PropTypes.number,
  pagination: paginationShape,
  size: PropTypes.string,
  children: childrenShape.isRequired,
  isFetching: PropTypes.bool,
  sourceComponent: PropTypes.string
};

BibSubPage.contextType = Context;

BibSubPage.defaultProps = {
  showHeaderCount: true,
  size: 'default'
};

export default injectIntl(BibSubPage);
